<template>
  <two-blocks-layout :navigate="navigate" v-bind="page">
    <span
      class="text-outline text-title-md"
      v-text="`${page.titolo1} `"
    /><br />
    <span class="text-title-md" v-text="page.titolo2" />
    <template #right>
      <div class="videoWrapper mx-2">
        <iframe
          width="560"
          height="315"
          src="https://www.youtube-nocookie.com/embed/9dIHyjHik9g?modestbranding=1&rel=0&showinfo=0&loop=0&color=white&iv_load_policy=3&autohide=1"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        />
      </div>
    </template>
  </two-blocks-layout>
</template>
<script>
import { axios } from "@/plugins/axios";
import TwoBlocksLayout from "@/components/page-layouts/TwoBlocksLayout.vue";

export default {
  components: { TwoBlocksLayout },
  props: { navigate: { default: null } },
  async beforeRouteEnter(to, from, next) {
    let page;
    try {
      page = await axios.get(`/pageContent${to.path}.json`);
    } catch (error) {
      page = {};
    } finally {
      next(vm => (vm.page = page.data));
    }
  }
};
</script>

<style scoped>
.videoWrapper {
  position: relative;
  padding-bottom: 56.25%; /* 16:9 */
  height: 0;
}
.videoWrapper iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>
<route>
{
  "name": "Plastic Free",
  "meta": {
      "tabOrder": 2
  }
}
</route>
